import React, {useEffect} from 'react';
import {useParams} from 'react-router-dom';

export const ExploreRedirect = () => {
  const {slug} = useParams();

  useEffect(() => {
    // Construction de l'URL de destination avec les paramètres de requête si présents
    const queryParams = window.location.search || '';
    const newUrl = `${process.env.REACT_APP_PUBLIC_URL}/${slug}${queryParams}`;

    // Redirection côté navigateur (pas React Router)
    window.location.href = newUrl;
  }, [slug]);

  // Afficher un message pendant la redirection
  return <div style={{padding: '2rem', textAlign: 'center'}}>Redirection en cours...</div>;
};
